import { useQuery } from '@tanstack/react-query'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Header from '@components/header'
import Layout from '@components/Layout'
import ViewSalesModal from '@components/Modal/ViewSalesModal/index'
import { columnsFinishedSales } from '@utils/columns'
import { debouncedSet } from '@utils/debounce'
import { fetchSales } from '@utils/fetchData'
import {
	handleNavigate,
	handleNavigateCar,
	handleNavigateSeries,
} from '@utils/navigateToPdf'
import { getToday } from '@utils/time'

const Sales = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()
	const { department, roleNames } = useSelector((state) => state.main)

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [pageSize, setPageSize] = useState(10)

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'sales',
			currentPage,
			cardName,
			docNum,
			startDate,
			endDate,
			slpName,
			roleNames.includes('Supplier') ||
			roleNames.includes('admin')
				? ''
				: department,
			'api/sales/tugallangan-sotuvlar',
			pageSize,
		],
		queryFn: fetchSales,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}
	const handleSlpNameChange = (val) => {
		debouncedSet(val, setSlpName)
	}

	const columns = columnsFinishedSales(
		t,
		handleRowClick,
		handleDocNumChange,
		handleCardNameChange,
		handleSlpNameChange,
		handleNavigate,
		handleNavigateCar,
		handleNavigateSeries,
	)

	const handlePaginationChange = (page, pageSize) => {
		setCurrentPage(page - 1)
		setPageSize(pageSize)
	}

	const handlePageSizeChange = (current, pageSize) => {
		setCurrentPage(0)
		setPageSize(pageSize)
	}

	return (
		<Layout>
			<Header
				title={'sales'}
				isShowPagination
				handlePageSizeChange={handlePageSizeChange}
				handlePaginationChange={handlePaginationChange}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
			/>
			<ViewSalesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				refetch={refetch}
			/>
		</Layout>
	)
}

export default Sales
